import { useEffect, useState } from "react";

import CONALEP from "./../../assets/images/escudos/conalepEDOMEX.png";

import "./WelcomeSplash.css";

const WelcomeSplash = ({ isLoading }) => {
    const [showSplash, setShowSplash] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    useEffect(() => {
        if (!isLoading) {
            setFadeOut(true); // Inicia la animación fadeOut
            const timeout = setTimeout(() => setShowSplash(false), 500); // delay para fade-out
            return () => clearTimeout(timeout);
        } else {
            setFadeOut(false); // Inicia la animación fadeOut
        }
    }, [isLoading]);

    if (!showSplash) return null;

    return (
        <div className={`splash-screen ${fadeOut ? "fade-out" : ""}`}>
            <div className="splash-content">
                <img src={CONALEP} alt="Cargando..." className="splash-logo" />
                <p className="splash-text">Cargando...</p>
            </div>
        </div>
    );
};

export default WelcomeSplash;